import { useState, type FormEvent } from 'react'
import { KeyRound, MessageCircleMore, UserPlus } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { Button, Field, Input, Modal } from './ui'

export function AuthDialog() {
  const auth = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(event: FormEvent) {
    event.preventDefault(); setBusy(true); setError('')
    try {
      if (auth.authMode === 'register') await auth.register(username, password, email)
      else await auth.login(username, password)
    } catch (e) { setError(e instanceof Error ? e.message : '认证失败') } finally { setBusy(false) }
  }

  const isWechat = auth.authMode === 'wechat'
  const title = isWechat ? '登录 MiXer AI' : auth.authMode === 'register' ? '创建开发者账号' : '账号密码登录'
  return <Modal open={auth.authOpen} onOpenChange={(open) => !open && auth.closeAuth()} title={title} description={isWechat ? '默认使用微信身份，账号密码登录作为备用方式。' : undefined}>
    {isWechat ? <div className="wechat-panel">
      <div className="wechat-icon"><MessageCircleMore size={30} /></div>
      <h3>使用微信安全登录</h3><p>前往微信官方授权页面，首次登录将自动创建平台账号。</p>
      <Button onClick={auth.startWechatLogin}><MessageCircleMore size={17}/> 前往微信授权</Button>
      <button className="text-button" onClick={() => auth.openAuth('login')}>使用账号密码登录</button>
    </div> : <form className="stack" onSubmit={submit}>
      <Field label="用户名" required><Input value={username} onChange={e => setUsername(e.target.value)} minLength={3} maxLength={32} autoComplete="username" required /></Field>
      {auth.authMode === 'register' && <Field label="邮箱" hint="选填，用于账号通知"><Input type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" /></Field>}
      <Field label="密码" required hint={auth.authMode === 'register' ? '至少 8 个字符' : undefined}><Input type="password" value={password} onChange={e => setPassword(e.target.value)} minLength={auth.authMode === 'register' ? 8 : 1} autoComplete={auth.authMode === 'register' ? 'new-password' : 'current-password'} required /></Field>
      {error && <div className="form-error">{error}</div>}
      <Button type="submit" loading={busy}>{auth.authMode === 'register' ? <><UserPlus size={17}/> 注册</> : <><KeyRound size={17}/> 登录</>}</Button>
      <button type="button" className="text-button" onClick={() => auth.openAuth('wechat')}>返回微信登录</button>
      {auth.authMode === 'login' && <button type="button" className="text-button" onClick={() => auth.openAuth('register')}>还没有账号？立即注册</button>}
    </form>}
  </Modal>
}
